import { useIntl } from 'react-intl-next';
const ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER = 'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)';
const resolveRecommendationRequest = ({
  baseUrl,
  context,
  includeUsers,
  includeTeams,
  query,
  maxNumberOfResults
}) => ({
  baseUrl,
  context,
  maxNumberOfResults,
  query: query !== null && query !== void 0 ? query : '',
  searchQueryFilter: ACTIVE_AND_NON_BOT_USER_SEARCH_FILTER,
  includeUsers: includeUsers !== null && includeUsers !== void 0 ? includeUsers : false,
  includeGroups: false,
  includeTeams: includeTeams !== null && includeTeams !== void 0 ? includeTeams : false
});
const asyncGetUserRecommendations = async (request, intl) => {
  try {
    const {
      getUserRecommendations
    } = await import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/getUserRecommendations" */'@atlaskit/smart-user-picker');
    return getUserRecommendations(request, intl);
  } catch (e) {
    // Ignore
  }
};
export const usePeopleAndTeamsQuery = (peopleAndTeamSections, maxItemsPerSection) => {
  const intl = useIntl();
  return async (query, {
    baseUrl,
    context,
    resolveTeamUrl,
    resolveUserUrl
  }) => {
    const teamsRequest = resolveRecommendationRequest({
      includeTeams: true,
      baseUrl,
      context,
      query,
      maxNumberOfResults: 20
    });
    // Separate requests enables better empty query results for each section
    const usersRequest = resolveRecommendationRequest({
      includeUsers: true,
      baseUrl,
      context,
      query,
      maxNumberOfResults: 20
    });
    try {
      var _teams$map, _users$map;
      const [teams, users] = await Promise.all([asyncGetUserRecommendations(teamsRequest, intl), asyncGetUserRecommendations(usersRequest, intl)]);
      const teamResults = (_teams$map = teams === null || teams === void 0 ? void 0 : teams.map(team => {
        return {
          title: team.name,
          id: team.id,
          meta: '',
          url: resolveTeamUrl ? resolveTeamUrl(team.id) : `/people/team/${team.id}`,
          iconUrl: team.avatarUrl
        };
      })) !== null && _teams$map !== void 0 ? _teams$map : [];
      const userResults = (_users$map = users === null || users === void 0 ? void 0 : users.map(user => {
        return {
          title: user.name,
          id: user.id,
          meta: user.title || '',
          url: resolveUserUrl ? resolveUserUrl(user.id) : `/people/${user.id}`,
          iconUrl: user.avatarUrl
        };
      })) !== null && _users$map !== void 0 ? _users$map : [];
      return {
        sections: [{
          ...peopleAndTeamSections.people,
          searchResults: maxItemsPerSection ? userResults.slice(0, maxItemsPerSection) : userResults
        }, {
          ...peopleAndTeamSections.teams,
          searchResults: maxItemsPerSection ? teamResults.slice(0, maxItemsPerSection) : teamResults
        }]
      };
    } catch (error) {
      return {
        sections: [{
          ...peopleAndTeamSections.people,
          searchResults: []
        }, {
          ...peopleAndTeamSections.teams,
          searchResults: []
        }]
      };
    }
  };
};